// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.g_oAeH {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex: 1;
  height: 100%;
  gap: var(--spacing-3);
  padding: var(--spacing-4);
}

.LCV7Ls {
  background: #fff0e5;
  border-radius: 50%;
  display: flex;
  height: 72px;
  width: 72px;
  align-items: center;
  justify-content: center;
}

.Oe0gWi {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
  margin: 0;
}

.VyncdM {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 400px;
}

.tKqACe {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3, 24px);
}

.qJ7BmE {
  margin-bottom: var(--spacing-1, 8px);
}

.hiJGUU {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: 600;
  font-size: var(--ibk-typography-fontSizeLg, 16px);
  line-height: 1.42;
  color: var(--surface-neutral-dark, #1f1f1f);
  margin: 0;
}

.h5K2ml {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1, 8px);
}

.krisxM {
  margin: calc(-1 * var(--spacing-3, 24px));
}

.kbrwYe {
  position: absolute;
  right: 24px;
  top: 80px;
  left: initial;
  width: 320px;
  min-width: initial;
  transform: initial;
}

@media (min-width: 768px) {
  .krisxM {
    flex-direction: row;
    justify-content: space-between;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/EmissorPaymentPage/components/EmissorPaymentContent/EmissorPaymentContent.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,OAAO;EACP,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iEAAiE;EACjE,gBAAgB;EAChB,iDAAiD;EACjD,iBAAiB;EACjB,2CAA2C;EAC3C,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;IACnB,8BAA8B;EAChC;AACF","sourcesContent":[".loadingContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  flex: 1;\n  height: 100%;\n  gap: var(--spacing-3);\n  padding: var(--spacing-4);\n}\n\n.loadingIcon {\n  background: #fff0e5;\n  border-radius: 50%;\n  display: flex;\n  height: 72px;\n  width: 72px;\n  align-items: center;\n  justify-content: center;\n}\n\n.loadingText {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.paymentForm {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 400px;\n}\n\n.content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3, 24px);\n}\n\n.header {\n  margin-bottom: var(--spacing-1, 8px);\n}\n\n.title {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: 600;\n  font-size: var(--ibk-typography-fontSizeLg, 16px);\n  line-height: 1.42;\n  color: var(--surface-neutral-dark, #1f1f1f);\n  margin: 0;\n}\n\n.paymentOptions {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1, 8px);\n}\n\n.footer {\n  margin: calc(-1 * var(--spacing-3, 24px));\n}\n\n.alertMessage {\n  position: absolute;\n  right: 24px;\n  top: 80px;\n  left: initial;\n  width: 320px;\n  min-width: initial;\n  transform: initial;\n}\n\n@media (min-width: 768px) {\n  .footer {\n    flex-direction: row;\n    justify-content: space-between;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingContainer": `g_oAeH`,
	"loadingIcon": `LCV7Ls`,
	"loadingText": `Oe0gWi`,
	"paymentForm": `VyncdM`,
	"content": `tKqACe`,
	"header": `qJ7BmE`,
	"title": `hiJGUU`,
	"paymentOptions": `h5K2ml`,
	"footer": `krisxM`,
	"alertMessage": `kbrwYe`
};
module.exports = ___CSS_LOADER_EXPORT___;
